import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import axios from "../common/axios";
import { Circles } from "react-loader-spinner";
import { useSetRecoilState } from "recoil";
import { userState } from "../common/atom/userState";

const checkSession = async () => {
  try {
    const response = await axios.post(
      `/dpis_logged_in`,
      {},
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      isValidSession: response.data.isLoggedIn,
      expiresIn: response.data.expiresIn,
    };
  } catch (error) {
    console.error("Error verifying session:", error);
    return { isValidSession: false };
  }
};

const checkShi = async () => {
  try {
    const response = await axios.post(
      `/dpcurrent_user`,
      {},
      { withCredentials: true, headers: { "Content-Type": "application/json" } }
    );
    return response.data.companyType === "삼성중공업";
  } catch (error) {
    console.error("Error verifying company type:", error);
    return false;
  }
};

const ProtectedRoute = ({ children, shiOnly = false }) => {
  const [isValidSession, setIsValidSession] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const setUser = useSetRecoilState(userState);

  useEffect(() => {
    const fetchData = async () => {
      const validity = await checkSession();
      if (!validity.isValidSession) {
        setIsLoading(false);
        navigate("/dplogin", { state: { from: location }, replace: true });
        setIsValidSession(false);
        return;
      }

      if (shiOnly) {
        const shi = await checkShi();
        if (!shi) {
          setIsLoading(false);
          navigate("/home", { replace: true });
          setIsValidSession(false);
          return;
        }
      }

      setIsLoading(false);
      setIsValidSession(true);
      setUser({
        isLoggedIn: true,
        expiresIn: validity?.expiresIn ?? null,
      });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className="loadingContainer">
        <Circles ariaLabel="loading" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }

  return isValidSession ? children : null;
};

export default ProtectedRoute;
